// Utilities
import { getIntegration } from '../../integrations';

// Import utils
import { isEmpty } from '@automator/shared/utils/is-empty';

/**
 * Returns information about a specific item using the item code. This won't return the item inside the recipe.
 * This returns global information
 *
 * @param {String} integrationCode The integration code. E.g. `WP`
 * @param {String} itemCode The item code. E.g. `VIEWPOST`
 * @return {Object|undefined} The item
 */
const getItemAction = ( integrationCode, itemCode ) => {
	if ( isEmpty( integrationCode ) ) {
		throw new Error( `directory/getItem: The integration code must be defined` );
	}

	if ( isEmpty( itemCode ) ) {
		throw new Error( `directory/getItem: The item code must be defined` );
	}

	// Get the integration
	const integration = getIntegration( integrationCode );

	// If the integration doesn't exist, neither does the item. Return `undefined`
	if ( isEmpty( integration ) ) {
		return;
	}

	// Check if the item exists
	if ( isEmpty( integration.actions.available ) ) {
		return;
	}

	// Check if the item exists
	if ( isEmpty( integration.actions.available[ itemCode ] ) ) {
		return;
	}

	return integration.actions.available[ itemCode ];
}

export default getItemAction;
